import * as THREE from "three";


const light = new THREE.AmbientLight( 0x404040 ); // soft white light
const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
light.add( directionalLight );
directionalLight.position.set(5,5,5);
const pointLight  = new THREE.PointLight(0xffffff,1); 
pointLight.position.set(2,2,2);

light.add( pointLight );


export default light;